import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgSubtract2Alt = function SvgSubtract2Alt(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 25 24",
    size: size
  }, props), React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#subtract2-alt_svg__clip0)"
  }, React.createElement("path", {
    d: "M12.984 0c-6.609 0-12 5.39-12 12s5.391 12 12 12c6.61 0 12-5.39 12-12s-5.39-12-12-12zm0 21.984C7.454 21.984 3 17.484 3 12c0-5.531 4.5-9.984 9.984-9.984 5.532 0 9.985 4.5 9.985 9.984a9.963 9.963 0 01-9.985 9.984z"
  }), React.createElement("path", {
    d: "M6.36 12.012c0-.53.465-.994.995-.994h11.27c.53 0 .994.464.994.994 0 .266-.133.53-.298.697-.166.165-.431.298-.697.298H7.356a1.02 1.02 0 01-.994-.995z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "subtract2-alt_svg__clip0"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z",
    transform: "translate(.984)"
  }))));
};

export default SvgSubtract2Alt;